<template>
  <v-container class="grey lighten-5" fluid>
    <v-row>
      <v-col cols="12" sm="6">
      <register/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import RegisterUser from "@/components/UserRegister";

export default {
  components: {
    register: RegisterUser,
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  })
};
</script>
